// FootPageNumber.jsx
import React from 'react';

function FootPageNumber({
  totalItems = 0,
  pageSize = 30,
  currentPage = 1,
  onPageChange = () => {},
}) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const pages = Array.from({ length: totalPages }, (_, idx) => idx + 1);

  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  return (
    <div>
      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
        <div className="flex flex-1 justify-between sm:hidden">
          <button
            type="button"
            disabled={!canGoPrev}
            onClick={() => canGoPrev && onPageChange(currentPage - 1)}
            className={`relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium ${
              canGoPrev ? 'text-gray-700 hover:bg-gray-50' : 'text-gray-300 cursor-not-allowed'
            }`}
          >
            Previous
          </button>
          <button
            type="button"
            disabled={!canGoNext}
            onClick={() => canGoNext && onPageChange(currentPage + 1)}
            className={`relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium ${
              canGoNext ? 'text-gray-700 hover:bg-gray-50' : 'text-gray-300 cursor-not-allowed'
            }`}
          >
            Next
          </button>
        </div>

        <div className="sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-700">
              Produtos{' '}
              <span className="font-medium">
                {totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1}
              </span>{' '}
              a{' '}
              <span className="font-medium">
                {Math.min(currentPage * pageSize, totalItems)}
              </span>{' '}
              de <span className="font-medium">{totalItems}</span> Encontrados
            </p>
          </div>

          <div>
            <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-xs">
              {/* Anterior */}
              <button
                type="button"
                disabled={!canGoPrev}
                onClick={() => canGoPrev && onPageChange(currentPage - 1)}
                className={`relative inline-flex items-center rounded-l-md px-2 py-2 inset-ring inset-ring-gray-300 focus:z-20 focus:outline-offset-0 ${
                  canGoPrev ? 'text-gray-400 hover:bg-gray-50' : 'text-gray-300 cursor-not-allowed'
                }`}
              >
                <span className="sr-only">Previous</span>
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="size-5">
                  <path
                    d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                    clipRule="evenodd"
                    fillRule="evenodd"
                  />
                </svg>
              </button>

              {/* Números */}
              {pages.map((p) => {
                const isCurrent = p === currentPage;
                return (
                  <button
                    key={p}
                    type="button"
                    aria-current={isCurrent ? 'page' : undefined}
                    onClick={() => onPageChange(p)}
                    className={
                      isCurrent
                        ? 'relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                        : 'relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20'
                    }
                  >
                    {p}
                  </button>
                );
              })}

              {/* Próximo */}
              <button
                type="button"
                disabled={!canGoNext}
                onClick={() => canGoNext && onPageChange(currentPage + 1)}
                className={`relative inline-flex items-center rounded-r-md px-2 py-2 inset-ring inset-ring-gray-300 focus:z-20 focus:outline-offset-0 ${
                  canGoNext ? 'text-gray-400 hover:bg-gray-50' : 'text-gray-300 cursor-not-allowed'
                }`}
              >
                <span className="sr-only">Next</span>
                <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="size-5">
                  <path
                    d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                    clipRule="evenodd"
                    fillRule="evenodd"
                  />
                </svg>
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FootPageNumber;